module.exports = __webpack_public_path__ + "static/media/bottom-right-card.c74c8db4.png";